import humanSize from 'human-size';
import { createAssetLink } from '../../utils/linkCreator';
import { IMAGE_DOWNSAMPLED, IMAGE_HIGH_RES } from '../../constants';

export default function link(context, content, key) {
  const { locator } = content.$;
  const { attachmentData } = context;
  const imageToShow = attachmentData
    .find(img => img['attachment-type'] === IMAGE_DOWNSAMPLED && img['file-basename'] === locator);
  const imageToDownload = attachmentData
    .find(img => img['attachment-type'] === IMAGE_HIGH_RES && img['file-basename'] === locator);

  return (
    <div className="abstract-attachment" key={key}>
      { imageToShow && (
      <img
        src={createAssetLink(imageToShow['attachment-eid'])}
        alt="Graphical abstract"
      />
      ) }
      { imageToDownload && (
      <div>
        <a
          href={createAssetLink(imageToDownload['attachment-eid'])}
          target="_blank"
          rel="noopener noreferrer"
        >
          {`Download high-res image (${humanSize(imageToDownload.filesize)})`}
        </a>
      </div>
      )}
    </div>
  );
}
